import React, { useState } from 'react'
import {ChevronDown} from 'lucide-react'
import { motion } from 'framer-motion'
import { Toaster } from 'react-hot-toast'

function App() {
  const [expandedFaq, setExpandedFaq] = useState<number | null>(null)

  const faqs = [
    {
      q: 'Preciso dar senha?',
      a: 'Não.'
    },
    {
      q: 'Quanto tempo leva?',
      a: 'Minutos após confirmação.'
    },
    {
      q: 'E se não entregar?',
      a: 'Suporte direto no WhatsApp.'
    }
  ]

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900">
      <Toaster position="top-center" />
      
      {/* Hero Section */}
      <section className="relative pt-20 pb-16 px-4">
        <div className="max-w-3xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-4">
              Teste 300 seguidores
            </h1>
            
            <p className="text-xl text-gray-400 mb-8">
              Veja no seu perfil agora — sem senha, sem risco.
            </p>

            <div className="mb-6">
              <p className="text-2xl text-white font-bold mb-4">
                💳 R$ 9,90 — Pagamento via PIX
              </p>
              <button
                onClick={() => document.getElementById('final-cta')?.scrollIntoView({ behavior: 'smooth' })}
                className="inline-block bg-gradient-to-r from-orange-500 to-red-600 text-white font-bold text-lg px-12 py-4 rounded-xl hover:shadow-lg hover:shadow-orange-500/50 transition-all duration-300"
              >
                👉 Ativar teste agora
              </button>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Process */}
      <section className="py-12 px-4 border-t border-b border-white/10">
        <div className="max-w-3xl mx-auto">
          <p className="text-center text-lg text-gray-300 mb-6">
            <strong className="text-white">Após clicar:</strong>
          </p>
          <p className="text-center text-gray-400 mb-8">
            Informe seu @ → Pagamento via PIX → Veja no seu perfil.
          </p>

          <div className="bg-white/5 border border-white/10 rounded-2xl p-6">
            <ul className="space-y-3 text-gray-300">
              <li>• 300 seguidores brasileiros</li>
              <li>• Perfis ativos</li>
              <li>• Entrega automática</li>
              <li>• Sem acesso à conta</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-16 px-4">
        <div className="max-w-3xl mx-auto">
          <p className="text-center text-lg text-white mb-6">
            ⭐⭐⭐ Depoimentos reais:
          </p>

          <div className="space-y-4">
            <div className="bg-white/5 border border-white/10 rounded-xl p-5">
              <p className="text-gray-300">
                "Entregou. Sem pedir senha. Vi no meu perfil."
              </p>
            </div>

            <div className="bg-white/5 border border-white/10 rounded-xl p-5">
              <p className="text-gray-300">
                "Funcionou. Chegou em minutos."
              </p>
            </div>

            <div className="bg-white/5 border border-white/10 rounded-xl p-5">
              <p className="text-gray-300">
                "Testei antes de investir mais. Deu certo."
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 px-4 bg-white/5 border-t border-white/10">
        <div className="max-w-2xl mx-auto">
          <h2 className="text-2xl font-bold text-white mb-8 text-center">
            ❓ Dúvidas rápidas?
          </h2>

          <div className="space-y-3">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="bg-white/5 border border-white/10 rounded-xl overflow-hidden"
              >
                <button
                  onClick={() => setExpandedFaq(expandedFaq === i ? null : i)}
                  className="w-full p-5 flex items-center justify-between text-left hover:bg-white/5 transition-colors"
                >
                  <span className="text-white font-medium">{faq.q}</span>
                  <ChevronDown 
                    className={`w-5 h-5 text-orange-400 flex-shrink-0 transition-transform ${expandedFaq === i ? 'rotate-180' : ''}`}
                  />
                </button>
                {expandedFaq === i && (
                  <div className="px-5 pb-5">
                    <p className="text-gray-400">{faq.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-16 px-4">
        <div className="max-w-2xl mx-auto text-center">
          <a
            id="final-cta"
            href="https://wa.me/5521969724009"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-gradient-to-r from-orange-500 to-red-600 text-white font-bold text-lg px-12 py-4 rounded-xl hover:shadow-lg hover:shadow-orange-500/50 transition-all duration-300 mb-4"
          >
            👉 Ativar teste agora
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-6 px-4 border-t border-white/10">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-gray-500 text-xs">
            © 2024 Teste de Seguidores
          </p>
        </div>
      </footer>
    </div>
  )
}

export default App
